import PlatformLayout from "@/layouts/PlatformLayout";
import DocumentScannerPage from "@/pages/tools/DocumentScannerPage";

const PlatformDocumentsPage = () => {
  return (
    <PlatformLayout activeTab="documents">
      <DocumentScannerPage />
    </PlatformLayout>
  );
};

export default PlatformDocumentsPage;
